import type React from 'react';
import Carousel, { type Settings } from 'react-slick';
import type { Button, CarouselData } from '../../../types/ChatWindow';
import type { MessageScheme } from '../../../types/configs';
import { CarouselArrows } from './CarouselArrows';
import CarouselCard from './CarouselCard';

type TCarouselProps = {
  elements: CarouselData['elements'];
  handleClick: (clickedButton: Button) => void;
  scheme: MessageScheme;
};

export const CarouselContainer: React.FC<TCarouselProps> = ({
  elements,
  handleClick,
  scheme,
}) => {
  const settings: Settings = {
    dots: false,
    infinite: true,
    speed: 750,
    slidesToScroll: 1,
    nextArrow: (
      <CarouselArrows
        classNames='carousel-arrow carousel-next'
        direction={'right'}
      />
    ),
    prevArrow: (
      <CarouselArrows
        classNames='carousel-arrow carousel-prev'
        direction={'left'}
      />
    ),
  };

  return (
    <Carousel {...settings}>
      {elements.map((element, index) => {
        return (
          <CarouselCard
            key={element.title + element.subtitle}
            scheme={scheme}
            handleClick={handleClick}
            element={element}
            index={index}
          />
        );
      })}
    </Carousel>
  );
};
